import { createSlice } from "@reduxjs/toolkit";
import { resetSearchCollections } from "./searchSlice";

const filterOrdersByStatus = (ordersData) => {
    
    const filteredOrders = {
      executed: [],
      current: [],
      pending: [],
    };
  
    ordersData &&
      ordersData.length > 0 &&
      ordersData.forEach((order) => {
        switch (order.status) {
          case "Success":
            filteredOrders.executed.push(order);
            break;
  
          case "Active":
            filteredOrders.current.push(order);
            break;

          case "Submitted":
            filteredOrders.current.push(order);
            break;
  
          case "Pending":
            filteredOrders.pending.push(order);
            break;
  
          default:
            break;
        }
      });
  
    return filteredOrders;
  };

const initialState = {
    loadingOrders: false,
    orders: {},
    singleOrder: {},
    editOrder: {},
    loading: false,
    error: null,
    featureCollection: {},
    uploadedCollection: {},
    uploadedFilename: '',
    successMessage: '',
    showSuccessMessage: false,
    providerConstellations: [],
    showOrbit: {},
    highlightOrbit: {},
    weatherForecast: null,
    weatherLoading: false,
    weatherError: null,
};

const saveFeatures = (orders) => {
    let features = [];
    // let set = true;
    for (let i = 0; i < orders.length; i++) {
        let feature = {
            type: 'feature',
            geometry: {
                type: '',
                coordinates: [],
            },
            properties: {
                // kind: 'normal'
                name: `name-${i + 1}`,
                'geodata:item_id': `featureId-${i + 1}`,
            },
        };
        if (orders[i]?.aoi?.coordinates?.length === 1) {
            feature.geometry.type = 'Point';
            feature.geometry.coordinates = orders[i].aoi.coordinates[0];
        } else if (orders[i]?.aoi?.coordinates?.length > 1) {
            // if(set) { 
            //     // temporarily setting kind to show highlighted order on landing page 
            //     // in future 
            //     // if we want to show local orders keep all of them normal
            // feature.properties.kind = 'highlighted';
            //     // do something
            // };
            feature.geometry.type = 'Polygon';
            feature.geometry.coordinates.push(orders[i].aoi.coordinates);
            // set = false;
        }
        features.push(feature);
    }
    const featureCollection = {
        type: 'FeatureCollection',
        features,
    }
    return featureCollection;
};

const ordersSlice = createSlice({
    name: 'ordersSlice',
    initialState,
    reducers: {
        getOrdersRequest: (state) => {
            state.loadingOrders = true;
            state.error = null;
        },
        getOrdersSuccess: (state, action) => {
            state.loadingOrders = false;
            state.orders = action.payload;
            state.featureCollection = saveFeatures(action.payload);
        },
        getSingleOrdersSuccess: (state, action) => {
            state.loadingOrders = false;
            state.singleOrder = action.payload;
        },
        getOrdersFailure: (state, action) => {
            state.loadingOrders = false;
            state.error = action.payload;
            state.featureCollection = {};
        },
        setUploadedFeatures: (state, action) => {
            state.uploadedFilename = action.payload.formatFileName
            state.uploadedCollection = action.payload.geojson;
        },
        resetUploadedFeatures: (state) => {
            state.uploadedFilename = '';
            state.uploadedCollection = {};
        },
        createOrderRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        createOrderSuccess: (state) => {
            state.loading = false;
        },
        createOrderFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        resetOrdersSlice: () => {
            return initialState;
        },
        setSuccessMessage: (state, action) => {
            state.successMessage = action.payload;
            state.showSuccessMessage = true;
        },
        resetSuccessMessage: (state) => {
            state.successMessage = '';
            state.showSuccessMessage = false;
        },
        resetOrderCollections: (state) => {
            state.featureCollection = {};
            state.uploadedCollection = {};
        },
        getConstellationsRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        getConstellationsSuccess: (state, action) => {
            state.loading = false;
            state.providerConstellations = action.payload;

            state.showOrbit = action.payload && action.payload.length > 0 ? action.payload[0] : {};
        },
        getConstellationsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        setProvider: (state, action) => {
            state.showOrbit = action.payload;
        },
        clearProvider: (state) => {
            state.providerConstellations = [];
            state.showOrbit = {};
            state.weatherForecast = null;
            state.weatherError = null;
        },
        getWeatherRequest: (state) => {
            state.weatherLoading = true;
            state.weatherForecast = null;
            state.weatherError = null;
        },
        getWeatherSuccess: (state, action) => {
            state.weatherLoading = false;
            state.weatherForecast = action.payload;
        },
        getWeatherFailure: (state, action) => {
            state.weatherLoading = false;
            state.weatherError = action.payload;
        },
        highlightOrbitpath: (state, action) => {
            state.highlightOrbit = action.payload;
        },
        resetHighlightOrbitpath: (state) => {
            state.highlightOrbit = {};
        },
        clearSingleOrder: (state) => {
            state.singleOrder = {};
        },
        setEditOrder: (state, action) => {
            state.editOrder = action.payload;
        },
        resetEditOrder: (state) => {
            state.editOrder = {};
        },
    },
});

export default ordersSlice.reducer;

export const {
    getOrdersRequest,
    getOrdersSuccess,
    getSingleOrdersSuccess,
    getOrdersFailure,
    setUploadedFeatures,
    resetUploadedFeatures,
    createOrderRequest,
    createOrderSuccess,
    createOrderFailure,
    resetOrdersSlice,
    setSuccessMessage,
    resetSuccessMessage,
    resetOrderCollections,
    getConstellationsRequest,
    getConstellationsSuccess,
    getConstellationsFailure,
    setProvider,
    clearProvider,
    highlightOrbitpath,
    resetHighlightOrbitpath,
    clearSingleOrder,
    setEditOrder,
    resetEditOrder,
    getWeatherRequest,
    getWeatherSuccess,
    getWeatherFailure,
} = ordersSlice.actions;

// thunk function to reset all the collections
export const resetAllCollections = () => async (dispatch, getState) => {
    // const state = getState();
    dispatch(resetOrderCollections());
    dispatch(resetSearchCollections());
};